import { useMemo } from "react";
import { useSdk } from "../../contexts/services/hooks/use-services-context";
import type { MailSend, ReplyForward } from "../../managers/mail/types/mail";
import type { ForwardMailRequestBody } from "../../managers/mail/types/mail.api";

export type MailComposer = {
    sendMail: (mailData: MailSend) => Promise<boolean>;
    replyToMail: (
        internetMessageId: string,
        replyData: ReplyForward,
        replyAll?: boolean,
    ) => Promise<boolean>;
    forwardMail: (payload: ForwardMailRequestBody) => Promise<boolean>;
    searchContact: (searchString: string) => Promise<string[]>;
};

export function useMailComposer(): MailComposer {
    const { mailManager } = useSdk();

    return useMemo<MailComposer>(
        () => ({
            sendMail: (...args) => mailManager.sendMail(...args),
            replyToMail: (...args) => mailManager.replyToMail(...args),
            forwardMail: (...args) => mailManager.forwardMail(...args),
            searchContact: (...args) => mailManager.searchContact(...args),
        }),
        [mailManager],
    );
}
